import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a variant-specific nutrition facts image
 * with zoom support. Updates automatically on variant change.
 *
 * @typedef {Object} NcnNutritionImageRefs
 * @property {HTMLDialogElement} [dialog] - The zoom dialog element
 *
 * @extends {Component<NcnNutritionImageRefs>}
 */
class NcnNutritionImage extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  handleVariantUpdate = (event) => {
    const updated = event.detail.data.html.querySelector(
      `ncn-nutrition-image[data-block-id="${this.dataset.blockId}"]`
    );
    if (!updated) return;
    this.innerHTML = updated.innerHTML;
  };

  open() {
    this.refs.dialog?.showModal();
  }

  close() {
    this.refs.dialog?.close();
  }

  /**
   * @param {MouseEvent} event
   */
  closeOnBackdrop(event) {
    if (event.target === this.refs.dialog) {
      this.close();
    }
  }
}

if (!customElements.get('ncn-nutrition-image')) {
  customElements.define('ncn-nutrition-image', NcnNutritionImage);
}
